/*
 This hook retrieves the button install bonus based on the `ignoreTargetingStatus` flag.
 1. For users with `ignoreTargetingStatus: true`
   a. all available bonuses are fetched. This doesn't include detailed bonus data.
   b. If bonus button is found, additional call based on bonus id is done to fetch detailed bonus data.
 2. For users with `ignoreTargetingStatus: false`, it directly fetches the relevant bonuses (including targeting).
*/
import { useGetBonusAvailable } from 'core/modules/Bonus/BonusAvailable/hooks/useGetBonusAvailable';
import { useGetBonusById } from 'core/modules/Bonus/BonusById/hooks/useGetBonusById';
import { useGetBonusOffers } from 'core/modules/BonusOffers/hooks';

export const useGetBonusButton = (ignoreTargetingStatus) => {
  const bonusAvailable = useGetBonusAvailable(ignoreTargetingStatus); // 1a
  const bonusButtonId = bonusAvailable.bonusButtonPlacement?.id;
  const bonusById = useGetBonusById(bonusButtonId); // 1b

  const bonusOffers = useGetBonusOffers(ignoreTargetingStatus); // 2

  if (ignoreTargetingStatus) {
    return {
      isLoaded: (bonusAvailable.isLoaded && !bonusButtonId) || bonusById.isLoaded,
      placement: bonusById.placement,
    };
  }

  return {
    isLoaded: bonusOffers.isLoaded,
    placement: bonusOffers.bonusButtonOffer,
  };
};
